import {RootState} from '@/store'

export const selectHexa = (state: RootState) => state.wallet.hexa
export const selectHepta = (state: RootState) => state.wallet.hepta
export const selectOcta = (state: RootState) => state.wallet.octa
export const selectReex = (state: RootState) => state.wallet.reex
export const selectEthos = (state: RootState) => state.wallet.ethos
export const selectTerra = (state: RootState) => state.wallet.terra
export const selectDominion = (state: RootState) => state.wallet.dominion
export const selectLoyalty = (state: RootState) => state.wallet.loyalty
export const selectOneGm = (state: RootState) => state.wallet.onegm
